// extracted by mini-css-extract-plugin
module.exports = {"editWrap":"styles_editWrap__2e4st","editMenu":"styles_editMenu__2RIKD","item":"styles_item__3_x-Y"};